export default {
  CREATE_LINK_SOWOS_POCKET_COMMAND: Symbol.for('CREATE_LINK_SOWOS_POCKET_COMMAND'),
  LINK_SOWOS_POCKET_REPOSITORY: Symbol.for('LINK_SOWOS_POCKET_REPOSITORY'),
};
